import { render, staticRenderFns } from "./booking_customer_list_tbn.vue?vue&type=template&id=39a66f6d&scoped=true&"
import script from "./booking_customer_list_tbn.vue?vue&type=script&lang=js&"
export * from "./booking_customer_list_tbn.vue?vue&type=script&lang=js&"
import style0 from "./booking_customer_list_tbn.vue?vue&type=style&index=0&id=39a66f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a66f6d",
  null
  
)

export default component.exports